<template>
  <el-container  style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
    <el-row :span="2" style="margin-top: 30px;">
        <el-select v-model="value"  filterable placeholder="请选择" >
            <el-option
              v-for="item in list"
              :key="item.name"
              :label="item.name"

              :value="item.value">
            </el-option>
          </el-select>
         <el-button type="success" round @click="upRds()">更新</el-button>
    </el-row>
    </el-row>

  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         value:'lifety_element_new_up',
         list:[
               {'name':'通用多维','value':'lifety_element_new_up'},
               {'name':'投放多维','value':'shtf_element_new_up'},
               {'name':'内部多维','value':'life_elementneibu_new_up'},
               {'name':'标识多维','value':'life_elementbiaoshi_new_up'},
               {'name':'一般多维','value':'life_elementyiban_new_up'},
               {'name':'地区多维','value':'lifecp_element_new_up'},
               {'name':'点面多维设备','value':'shsb_element_new_up'},
               {'name':'点面多维地球','value':'shdq_element_new_up'},
               {'name':'线类多维设备','value':'flysb_element_new_up'},
               {'name':'线类多维地球','value':'zxdq_element_new_up'},
               {'name':'突发多维设备','value':'shss_element_new_up'},
               {'name':'突发多维地球','value':'shsdq_element_new_up'},
               {'name':'指向元素','value':'lifezx_element_new_up'},
               {'name':'飞行元素','value':'fly_element_new_up'},
               {'name':'连接元素','value':'lx_element_new_up'},
               {'name':'元素适配','value':'sh_equipment_up'},

         ],

      }
    },
	directives: {
    },
    created() {

    },

	methods:{

    upRds(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          value:this.value,


      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yuanSuRds'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.$message({
            	type: 'sucsess',
            	message: '更新成功'
            });
         }else{

           this.$message({
           	type: 'error',
           	message: '更新失败'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>



// WEBPACK FOOTER //
// src/components/main/elementUp.vue